import axios, { AxiosResponse, AxiosRequestConfig, AxiosError } from "axios";
import type { Response } from "./types";
// import { auth } from '@/utils';
import { showToast } from "vant";
import router from "@/router";
import { loginData } from '@/store/modules/login'

axios.defaults.timeout = 1000 * 60;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";

console.log(import.meta.env.VITE_APP_API_BASE_URL, "import.meta");
// 创建axios实例
const service = axios.create({
  // 根据不同env设置不同的baseURL
  baseURL: `${import.meta.env.VITE_APP_API_BASE_URL}`,
  timeout: 20000, // 请求超时时间
});

// axios实例拦截请求
service.interceptors.request.use(
  (config: any) => {
    const loginStore = loginData();
    if (loginStore.token) {
      config.headers = {
        ...config.headers,
        token: loginStore.token //loginStore.token,
      };
    } else {
      // showToast("缺少token或者token无效");
    }

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// axios实例拦截响应
service.interceptors.response.use(
  // 2xx时触发
  (response: AxiosResponse<Response>) => {
    // response.data就是后端返回的数据，结构根据你们的约定来定义
    const { code, message } = response.data;
    const resultCode = response.data["resultCode"]
    if(resultCode == 310) {
      const loginStore = loginData();
      loginStore.updateToken('')
      location.reload()
    }
    let errMessage = "";
    switch (code) {
      case 0:
        break;
      case 1: // token过期
        errMessage = "Token expired";
        router.push("/login");
        break;
      case 2: // 无权限
        errMessage = "No permission";
        break;
      default:
        errMessage = message;
        break;
    }
    if (errMessage) console.error(errMessage);
    if (response && response.status === 200) {
      const data:any = response.data;
      data.response = response;
      return data;
    }
    return response;
  },
  // 非2xx时触发
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

export type { AxiosResponse, AxiosRequestConfig };

export default service;
